import * as types from "../action/ActionType";
import { ALL_PROJECT_INITIAL } from "../store/InitialStore";
export default function AllProjectListReducer(state = ALL_PROJECT_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.ALL_PROJECTS_LIST:
      return (state = payload);
    default:
      return state;
  }
}
